﻿import Vue from "vue";
import common = require("../../common");
import context = require("../context");
import core = require("../../core");
import EditVue = require("../vue/EditVue");
import HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction");
import utilities = require("../utilities");
import DefaultTransfertSearchBoxes = require("./DefaultTransfertSearchBoxes");

//declare function require(name: string): any;

interface ISettings {
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId_top: string;
    vueElId_bottom: string;
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    /** Definie si le clique du bouton Annuler ("cancel") doit faire un "Back history" ou s'il doit aller a l'API (default: true) */
    useBrowserHistoryToGoBackOnCancel?: boolean;
    filterByFederationRegionaleId?: boolean;
    /** settings du DefaultTransfertSearchBoxesSettings */
    transfertSearchBoxesSettings?: any;
}

class AssocierDesMunicipalitesAuSyndicatSpecialise implements common.IWebComponent {
    private _isEditionAlwaysOn = false;
    private _isInit = false;
    private _editVue_top = null as EditVue;
    private _editVue_bottom = null as EditVue;
    private _loader = null as core.Loader;
    private _previousPageUrl: string;
    private _vueElId_top: string;
    private _vueElId_bottom: string;
    private _useBrowserHistoryToGoBackOnCancel: boolean;
    private _transfertSearchBoxes: DefaultTransfertSearchBoxes;

    // Initialisation
    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._vueElId_top = s.vueElId_top || null;
        this._vueElId_bottom = s.vueElId_bottom || (() => { throw "La propriété 'settings.vueElId_bottom' est requise."; })();
        this._useBrowserHistoryToGoBackOnCancel = s.useBrowserHistoryToGoBackOnCancel !== false;//default is TRUE
        this._previousPageUrl = s.previousPageUrl || null;

        //this._loader = new core.Loader(this._vueElId_top);

        this._transfertSearchBoxes = s.transfertSearchBoxesSettings
            ? new DefaultTransfertSearchBoxes().init(s.transfertSearchBoxesSettings) as DefaultTransfertSearchBoxes
            : null;

        this.setupVues(s);

        return context.components.add(this);
    }

    private setupVues(s: ISettings) {
        if (this._vueElId_top) {
            // TOP
            Vue.prototype.$initialData = {
                vueElId: this._vueElId_top
            };
            this._editVue_top = new EditVue();//.setManageButtonsOnFormModeChange(false);
            this._editVue_top.shared.setActionCallback(a => {
                this.onFormAction(a);
            });
            this._editVue_top.shared.setupForm(this._isEditionAlwaysOn);
        }

        // BOTTOM
        Vue.prototype.$initialData = {
            vueElId: this._vueElId_bottom
        };
        this._editVue_bottom = new EditVue().setManageButtonsOnFormModeChange(false);
        this._editVue_bottom.shared.setActionCallback(a => {
            this.onFormAction(a);
        });
        this._editVue_bottom.shared.setupForm(this._isEditionAlwaysOn);
    }

    private onFormAction(action: HotEditableFormAction) {

        const actionType = action.getActionType();

        if (action.getFieldName() === 'FilterByFederationRegionaleId' && actionType === common.HotEditableActionTypes.unknown) {
            this.onFilterByFederationRegionaleIdUpdated(action.getFieldTextualValue())
            return;
        }

        if (actionType === common.HotEditableActionTypes.cancel && this._useBrowserHistoryToGoBackOnCancel) {
            utilities.redirect(this._previousPageUrl);
            return;
        }
    }

    private onFilterByFederationRegionaleIdUpdated(id: string) {
        const k = 'federationRegionaleId';
        const url = utilities.updateUrlParameter(utilities.currentUrl(), k, id);
        utilities.updateBrowserUrl(url, true);
        setTimeout(() => {
            // left
            this._transfertSearchBoxes.searchBoxLeft.customData['guidValues'][k] = id;
            this._transfertSearchBoxes.searchBoxLeft.refresh();
            // right
            this._transfertSearchBoxes.searchBoxRight.customData['guidValues'][k] = id;
            this._transfertSearchBoxes.searchBoxRight.refresh();
        }, 1);
    }
}

export = AssocierDesMunicipalitesAuSyndicatSpecialise;
